"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
var exceptions_1 = require("../exceptions");
function defaultLevelSelector(fps) {
    if (fps < 10) {
        return "error";
    }
    if (fps < 20) {
        return "warn";
    }
    return "log";
}
function measureFPS(config) {
    var lastTime;
    function init(time) {
        lastTime = time;
        window.requestAnimationFrame(measure);
    }
    function measure(time) {
        var fps = time - lastTime < 16 ? 60 : 1000 / (time - lastTime);
        var level = config.levelSelector(fps);
        if (config.logger) {
            config.logger[level]("mogwai ", "fps       ", fps);
        }
    }
    window.requestAnimationFrame(init);
}
function fps() {
    var config = {
        delay: 500,
        levelSelector: defaultLevelSelector,
        logger: null
    };
    var initialTime = -Infinity;
    var enabled;
    function loop(time) {
        if (time - initialTime > config.delay) {
            measureFPS(config);
            initialTime = time;
        }
        if (!enabled)
            return;
        window.requestAnimationFrame(loop);
    }
    function fpsMogwai() {
        if (!config.logger) {
            throw new exceptions_1.LoggerRequiredException();
        }
        enabled = true;
        window.requestAnimationFrame(loop);
    }
    fpsMogwai.cleanUp = function () {
        enabled = false;
        return fpsMogwai;
    };
    utils_1.configurable(fpsMogwai, config);
    return fpsMogwai;
}
exports.fps = fps;
